import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate , useNavigate} from 'react-router-dom';
import {Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';

import { loginUser } from '../../redux/actions';
import { isUserAuthenticated } from '../../helpers/authUtils';
import SmallLoader from '../../components/SmallLoader/SmallLoader';
import { CiMail } from "react-icons/ci";
import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";



const Login = ({ onLoginSuccess, setIsLoginModalOpen, setIsForgotModalOpen }) => {
    const { t, i18n } = useTranslation();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [passwordVisible, setPasswordVisible] = useState(false);
    // const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();
    const [message, setMessage] = useState("");
    const { user, loading, error } = useSelector((state) => state.Auth);
    const navigate = useNavigate();
    const handleValidSubmit = async (event, values) => {
        const res = await dispatch(loginUser(values.username, values.password));
        console.log("test", res.success);
             // dispatch(failure(error.toString()));
            setMessage("");
        if (res?.success === true) {
            setIsLoginModalOpen(false);
            // window.location.reload();
            navigate('/games')
            const element = document.querySelector('.test');
            if (element) {
                element.style.display = 'none';
            }
        }
        
    };

  useEffect(() => {
    // Full query: ?login+Password%20is%20updated
    const q = location.search.replace("?", "");

    if (q.includes("+")) {
      const [key, rawMsg] = q.split("+");

      if (key === "login") {
        setMessage(decodeURIComponent(rawMsg));
      }
    }
  }, [location]);

    const renderRedirectToRoot = () => {
        if (isUserAuthenticated()) {
            if (user.status === "blocked") {
                return <Navigate to='/request' />;
            } else {
                return <Navigate to='/' />;
            }
        }
    };

    return (
        <>
            {/* {renderRedirectToRoot()} */}
            <section className=" ">
                <div className="">
                    <div className="">
                        <div className=''>
                            <div className=''>
                                {/* Right container */}
                                <div className="account__form__wrapper mobile-view-login">
                                    <div className="row">
                                        <div className="col-12">
                                            <img src="/images/logo.png" className="login" />
                                            <h3 className="h3_heading">{t(`loginPop.login`)}</h3>
                                        </div>
                                    </div>
                                    {error && (
                                        <Alert color="danger" isOpen={!!error}>
                                            <div>
                                                {error}
                                                {error === "Your account has been blocked due to Time Out. If you want to unblock it, please send a request to the admin." && (
                                                    <a style={{ color: 'blue', marginLeft: 5 }} href="/time-out-request" target="_blank" rel="noopener noreferrer">
                                                        Contact Atom Support
                                                    </a>
                                                )}
                                            </div>
                                        </Alert>
                                    )}
                                        {/* Popup Message */}
                                        {message && 
                                            <Alert color="success" isOpen={message}>
                                                {message}   
                                            </Alert>
                                        }
                                       
                                    <AvForm className="" onValidSubmit={handleValidSubmit}>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <div className="input-icon-wrapper"  >
                                                    <AvField
                                                        id="username"
                                                        type="text"
                                                        name="username"
                                                        value={username}
                                                        className="form--control2 style--two"
                                                        placeholder={t(`loginPop.placeholderE`)}
                                                        validate={{ required: { value: true, errorMessage: t('loginPop.validation.enterEmail') } }

                                                        }
                                                       
                                                        onChange={(e) => setUsername(e.target.value)}
                                                    />
                                                    <CiMail className="input-icon1" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <div className="form-group" >
                                                    <div className="input-icon-wrapper">
                                                        <AvField
                                                            id="password"
                                                            name="password"
                                                            type={passwordVisible ? 'text' : 'password'}
                                                            className="form--control2 style--two"
                                                             placeholder={t(`loginPop.placeholderPas`)}
                                                            value={password}
                                                            onChange={(e) => setPassword(e.target.value)}
                                                            validate={{
                                                                required: { value: true, errorMessage: t('loginPop.validation.enterPassword')},
                                                            }}
                                                        />
                                                        <span
                                                            onClick={() => setPasswordVisible((prev) => !prev)}
                                                            style={{
                                                                position: 'absolute',
                                                                top: '50%',
                                                                right: '10px',
                                                                transform: 'translateY(-50%)',
                                                                cursor: 'pointer',
                                                                zIndex: 5,
                                                                color: '#DEDEDE',
                                                                padding: '5px',
                                                                fontSize: '20px'
                                                            }}
                                                        >
                                                            {passwordVisible ? <FaRegEye /> : <FaRegEyeSlash />}
                                                        </span>
                                                    </div>
                                                </div> </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="form-group">
                                                <button class="custom-login2" type="submit" disabled={loading} >
                                                    {/* {loading ? "Loading..." : "Login"} */}
                                                     {t(`loginPop.login`)}
                                                </button>
                                                {/* <button className="active cstm_btn w-100 btn--round"  type="submit">Login</button> */}
                                            </div>
                                                {loading && <SmallLoader />}
                                        </div>
                                    </AvForm>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Login;
